import { LOCAL_STORAGE_KEYS } from '../../utils/constants'
import { apiHeaders } from '../../utils/utils'
import axiosWrapper from '../helpers/api'
import { ERequestUrl, EMethods } from '../helpers/requests'

export const getWishList = () =>
  axiosWrapper({ method: EMethods.get, url: ERequestUrl.wishlist })

export const addToWishList = (code: string) =>
  axiosWrapper({
    method: EMethods.post,
    url: ERequestUrl.wishlist,
    headers: {
      'Content-Type': 'application/json',
      ...apiHeaders(localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE)),
    },
    data: { code },
  })

export const removeFromWishList = (code: string) =>
  axiosWrapper({
    method: EMethods.delete,
    url: ERequestUrl.wishlist,
    headers: {
      'Content-Type': 'application/json',
      ...apiHeaders(localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE)),
    },
    uid: code,
  })

export const checkWishListExistence = (productIds: number[]) =>
  axiosWrapper({
    method: EMethods.post,
    url: ERequestUrl.wishlist,
    uid: 'check',
    headers: {
      'Content-Type': 'application/json',
      ...apiHeaders(localStorage.getItem(LOCAL_STORAGE_KEYS.CONNEXION_TYPE)),
    },
    data: { productIds },
  })
